export const GLOBAL_MORE_MENU_INTERACTION_ID = 'globalMoreMenuLoad';
export const GLOBAL_MORE_MENU_INTERACTION_NAME = 'global-more-menu-load';
